// « Coût IA : X DH » on the admin order page (owner, 2026-10-22): this order's
// lifetime AI cost from the ledger (worker GET /dashboard/ai-costs/order/:id,
// migration 263). finance.view only (the caller gates it). Unreadable → « — ».
import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/lib/dashboardApi';
import { formatDecimal } from '@/lib/homeDashboard';
import { useT } from '@/lib/i18n';

export function OrderAiCostLine({ shopifyOrderId }: { shopifyOrderId: string }) {
  const { t, lang } = useT();
  const q = useQuery({
    queryKey: ['order-ai-cost', shopifyOrderId] as const,
    queryFn: () => dashboardApi.orderAiCost(shopifyOrderId),
    staleTime: 60_000,
    retry: false,
  });
  const d = q.data;
  const value = q.isLoading ? '…' : !d || d.missing || d.mad == null ? '—' : `${formatDecimal(Math.round(d.mad * 100) / 100, lang)} DH`;
  return (
    <div data-order-ai-cost className="flex items-baseline justify-between text-xs mt-2 pt-1.5 border-t border-gray-100 dark:border-adm-line">
      <span className="text-adm-muted">{t('Coût IA')}</span>
      <span className="tabular-nums font-semibold text-adm-ink" title={d && !d.missing ? t('{n} appels', { n: d.calls }) : undefined}>
        {value}{d && !d.missing && d.calls > 0 ? <small className="font-normal text-adm-muted"> · {t('{n} appels', { n: d.calls })}</small> : null}
      </span>
    </div>
  );
}
